import React from 'react';
import PropTypes from 'prop-types';
import { sortBy, groupBy, min, map } from 'lodash';
import { Table } from 'antd';
import classnames from 'classnames';
import style from './index.scss';
import { normalizeAlertScore } from '../../../../util/normalization';
import { getInDecimal } from '../../../../services/util';
import { SingleDataColumn } from '../../../common/components';

const configToColumns = (config, dataMapping) => {
  return map(groupBy(config.widgetConfig, 'columnName'), (v, k) => {
    const children = v.filter((col) => {
      return col.columnVisibility;
    });
    return {
      columnName: k,
      columnIndex: min(map(v, (i) => i.columnIndex)),
      colSpan: children.length,
      children: children
    };
  })
    .filter((col) => col.children.length > 0)
    .sort((a, b) => a.columnIndex - b.columnIndex)
    .map((col) => {
      return {
        title: col.columnName,
        key: col.columnName,
        colSpan: col.colSpan,
        children: sortBy(col.children, ['columnIndex']).map((item) => {
          return {
            title: item.columnDetail.map((i) => {
              return <div key={i.itemName}>{i.itemLabel}</div>;
            }),
            key: item.columnDetail.map((i) => i.itemName).join('-'),
            render: (value, row) => {
              if (row['alertScore']) {
                row['alertScore'] = normalizeAlertScore(
                  getInDecimal(row['alertScore'])
                );
              }

              return item.columnDetail.map((i) => {
                if (i.itemName === 'rules') {
                  return (
                    <div className={style.ellipsisBlock}>
                      <SingleDataColumn.Ellipsis pop value={row[i.itemName]} />
                    </div>
                  );
                } else if (i.itemName === 'alertLevel') {
                  return row[i.itemName]?.map((level) => <div>{level}</div>);
                }

                return (
                  <div
                    key={i.itemName}
                    title={
                      i.itemName === 'alertScore'
                        ? normalizeAlertScore(row?.detailedAlertScore)
                        : ''
                    }>
                    {dataMapping[i.itemName]
                      ? dataMapping[i.itemName](row)
                      : i.itemName in row &&
                        row[i.itemName] &&
                        row[i.itemName] !== 'null'
                      ? row[i.itemName].toString()
                      : i.itemName !== 'alertScore' && '-'}
                  </div>
                );
              });
            }
          };
        })
      };
    });
};

const CRSDataTable = ({
  GSConfig = {},
  data = [],
  loadMore,
  hasMore,
  loading,
  rowKey = 'id',
  dataMapping = {},
  pagination
}) => {
  const columns = configToColumns(GSConfig, dataMapping);
  return (
    <Table
      bordered
      className={classnames(style.table)}
      columns={columns}
      dataSource={data}
      pagination={pagination ? pagination : false}
      footer={
        hasMore
          ? () => (
              <div className={style.loadMore}>
                <a onClick={loadMore}>Load more</a>
              </div>
            )
          : null
      }
      loading={loading}
      rowKey={rowKey}
    />
  );
};

CRSDataTable.propTypes = {
  GSConfig: PropTypes.object,
  data: PropTypes.array,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  rowKey: PropTypes.string,
  dataMapping: PropTypes.object
};

export default CRSDataTable;
